import React from 'react';

import DatePicker from 'components/DatePicker';
import calendarIcon from './assets/calendar.svg';
import {DATE_FORMAT} from 'utils/datetime';

import './styles.css';

const DisabledDatePicker = ({placeholder = DATE_FORMAT}) => (
  <div className="DisabledDatePicker">
    <div className="inputWrapper">
      <div className="icon">
        <img src={calendarIcon} alt="Calendar icon" />
      </div>
      <DatePicker placeholder={placeholder} disabled={true} />
    </div>
  </div>
);

export default DisabledDatePicker;
